var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPoliciesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.695,
    height: 40.618,
    viewBox: "0 0 22.332 21.059",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58306",
    "data-name": "Group 58306",
    transform: "translate(-594.275 -180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M13.9,19.594H2.261A2.213,2.213,0,0,1,0,17.333V2.261A2.213,2.213,0,0,1,2.261,0H17.333a2.212,2.212,0,0,1,2.261,2.261V9.372h-1.4V2.261a.825.825,0,0,0-.269-.592.83.83,0,0,0-.593-.269H2.261a.83.83,0,0,0-.593.269.826.826,0,0,0-.268.592V17.333a.829.829,0,0,0,.268.592.83.83,0,0,0,.593.269H13.9v1.4Zm-.854-6.754H4.9v-1.4h8.144v1.4Zm2.825-3.613H4.9v-1.4H15.868v1.4ZM12.7,5.474H4.9V3.924h7.8v1.55Z",
    transform: "translate(594.275 180)",
    fill: "#1447b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "encrypted_24dp_FILL0_wght300_GRAD0_opsz24",
    d: "M183.838-848.965a4.943,4.943,0,0,1-2.749-1.955A5.584,5.584,0,0,1,180-854.278v-2.945l2.074-.447,1.764-1.273,1.788,1.273,2.05.447v2.945a5.584,5.584,0,0,1-1.089,3.358A4.943,4.943,0,0,1,183.838-848.965Z",
    transform: "translate(428.93 1050.024)",
    fill: "#1447b2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoliciesIcon);
export default __webpack_public_path__ + "static/media/policies_icon.cce96fef40bf567a6c2a1f499a5c8400.svg";
export { ForwardRef as ReactComponent };